import { SEOHead } from '../components/SEOHead';
import { AppNavigationBar } from '../components/AppNavigationBar';
import { Upload } from 'lucide-react';

export default function AppUpload() {
  return (
    <div className="relative w-full h-screen bg-[var(--color-white)]">
      <SEOHead title="Upload – pixcapture.app" description="Fotos hochladen" path="/app/upload" />
      
      <div className="flex flex-col items-center justify-center h-full px-8">
        <Upload className="h-16 w-16 text-[var(--color-accent)] mb-4" />
        <h1 className="text-[24px] mb-2">Fotos hochladen</h1>
        <p className="text-[var(--color-grey)] text-center mb-8">
          Wählen Sie Fotos aus Ihrer Galerie oder fotografieren Sie direkt
        </p>
        <button className="px-6 py-3 bg-[var(--color-accent)] text-white rounded-md">
          Fotos auswählen
        </button>
      </div>

      <AppNavigationBar activeRoute="/app/upload" />
    </div>
  );
}
